import React, { useEffect, useState } from "react";
import "../../css/custom.css";
import "../../css/style.css";
import { useInventoryProductContext } from "../../../Context/Cache/InventoryProductContext";
import { useCartInventoryContext } from "../../../Context/Cache/CartInventoryContext";
import { Link } from "react-router-dom";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import axios from "axios";

const IncomingFooter = () => {
  // const {addToCart} = useInventoryProductContext()
  const { handleStoreInCache, selectedRows, infoList, setInfoList, cartProduct, editOrder,
    setEditOrder } = useCartInventoryContext();

  const handleAddToCart = () => {
    // addToCart()
    handleStoreInCache();
  };
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const cartProductdetails = cartProduct || [];
  const hasCartProducts = cartProduct && cartProduct.length > 0;
  // Amit Change
  useEffect(() => {
    if (infoList.length > 0) {
      infoList.forEach(element => {
        toast.success(element);
        console.log("toast inside Inventry");
      });
      setInfoList([]);
    }

  }, [infoList])

  const handleAddToOrder = async () => {
    if (selectedRows.length > 0) {
      console.log("Button disbaled");
      
      try {
        setLoading(true);

        console.log("Selected Rows", selectedRows);
        console.log("Quote Type: ", editOrder[0].quotetype);

        const processData = (data, type) => {

          console.log("Quote Product Lines: ", editOrder[0].productlines);

          var isALreadyPresent = false;

          const isProductAlreadyPresent = () => {
            const quoteProductLines = [...editOrder[0].productlines];

            return selectedRows.some((selectedRow) => {

              var existingProduct;

              if (editOrder[0].quotetype === 1) { // inventory
                existingProduct = quoteProductLines.find(
                  (product) => product.productId === selectedRow.productid
                );
              }
              else if (editOrder[0].quotetype === 0) { // atu
                existingProduct = quoteProductLines.find(
                  (product) => product.productId === selectedRow.nyc_atuid
                );
              }

              console.log("Existing Product", existingProduct);

              if (existingProduct) {

                var value1 = (existingProduct.quantity);
                if (value1) {
                  toast.warning(`Offer already contains ${value1} quantity with UPC no: ${existingProduct.nyc_upc}`);
                }
                else {
                  toast.warning(`Offer already contains UPC no: ${existingProduct.nyc_upc}`);
                }

                return true;

              }

              return false;
            })
          }

          isALreadyPresent = isProductAlreadyPresent();

          console.log("IS product present? ", isALreadyPresent);

          if (!isALreadyPresent) {
            for (let item of data) {
              if (type === 0) {// atu

                const price = Number(item.price);
                const counterOffer = item.counterOffer !== undefined ? Number(item.counterOffer) : 0;
                const requestedQuantity = item.requestedQuantity !== undefined ? Number(item.requestedQuantity) : 0;

                if (price === 0) {
                  toast.error(`Product has price set to zero.`);
                  setLoading(false);
                  return;
                }
                if (requestedQuantity === 0) {
                  toast.error(`Product has Requested Quantity set to zero.`);
                  setLoading(false);
                  return;
                }

              } else { // inventory
                const price = Number(item.price);
                const counterOffer = item.counterOffer !== undefined ? Number(item.counterOffer) : 0;
                const requestedQuantity = item.requestedQuantity !== undefined ? Number(item.requestedQuantity) : 0;

                if (item.producttypecode != 3) {
                  if (price === 0 && counterOffer === 0) {
                    toast.error(`Product ${item.name} has both price and counter offer set to zero.`);
                    setLoading(false);
                    return;
                  }
                  if (price === 0) {
                    toast.error(`Product ${item.name} has price set to zero.`);
                    setLoading(false);
                    return;
                  }
                }
                if (counterOffer === 0) {
                  toast.error(`Product has offer price set to zero.`);
                  setLoading(false);
                  return;
                }
                if (requestedQuantity === 0) {
                  toast.error(`Product has Requested Quantity set to zero.`);
                  setLoading(false);
                  return;
                }
                if (counterOffer < 0) {
                  toast.error(`Product has Offer Price set to zero.`);
                  setLoading(false);
                  return;
                }
              }
            }

            return data.map(item => {
              if (type === 0) {

                var atuItem = {};

                if (item.nyc_atuid) {
                  atuItem["nyc_atuProductId@odata.bind"] = `/nyc_atus(${item.nyc_atuid?.replace("}", "").replace("{", "")})`;
                }

                if (item._transactioncurrencyid_value) {
                  atuItem["transactioncurrencyid@odata.bind"] = `/transactioncurrencies(${item._transactioncurrencyid_value?.replace("}", "").replace("{", "")})`;
                }

                if (editOrder[0].quoteid) {
                  atuItem["nyc_QuoteATULineItemId@odata.bind"] = `/quotes(${editOrder[0].quoteid?.replace("}", "").replace("{", "")})`;
                }

                if (item.nyc_sku) {
                  atuItem["nyc_sku"] = item.nyc_sku;
                }

                if (item.nyc_upc) {
                  atuItem["nyc_name"] = item.nyc_upc;
                }

                if (item.nyc_name) {
                  atuItem["nyc_color"] = item.nyc_name
                }

                if (item._nyc_brand_value) {
                  atuItem["nyc_Brand@odata.bind"] = `/nyc_atucategories(${item._nyc_brand_value?.replace("}", "").replace("{", "")})`;
                }

                if (item.nyc_size) {
                  atuItem["nyc_size"] = item.nyc_size;
                }

                if (item.nyc_productname) {
                  atuItem["nyc_productname"] = item.nyc_productname
                }

                if (item.counterOffer) {
                  atuItem["nyc_counteroffer"] = parseFloat(item.counterOffer)
                }
                else {
                  atuItem["nyc_counteroffer"] = 0;
                }

                if (item.nyc_cost) {
                  atuItem["nyc_cost"] = item.nyc_cost;
                }

                if (item.nyc_price) {
                  atuItem["nyc_price"] = item.nyc_price;
                }

                if (item._nyc_supplier_value) {
                  atuItem["nyc_Supplier@odata.bind"] = `/accounts(${item._nyc_supplier_value?.replace("}", "").replace("{", "")})`;
                }

                if (item.requestedQuantity) {
                  atuItem["nyc_requestedquantity"] = item.requestedQuantity
                }
                else {
                  atuItem["nyc_requestedquantity"] = 0;
                }

                atuItem["nyc_quoteproductstatus"] = 219640002;

                return atuItem;

              } else {

                var inventoryItem = {}

                if (item.productid) {
                  inventoryItem["productid@odata.bind"] = `/products(${item.productid?.replace("{", "").replace("}", "")})`;
                }

                if (item._defaultuomid_value) {
                  inventoryItem["uomid@odata.bind"] = `/uoms(${item._defaultuomid_value?.replace("{", "").replace("}", "")})`;
                }

                if (item._transactioncurrencyid_value) {
                  inventoryItem["transactioncurrencyid@odata.bind"] = `/transactioncurrencies(${item._transactioncurrencyid_value?.replace("{", "").replace("}", "")})`;
                }

                if (editOrder[0].quoteid) {
                  inventoryItem["quoteid@odata.bind"] = `/quotes(${editOrder[0].quoteid?.replace("}", "").replace("{", "")})`;
                }

                inventoryItem["ispriceoverridden"] = true;
                inventoryItem["nyc_quoteproductstatus"] = 219640002;
                inventoryItem["propertyconfigurationstatus"] = 2;

                if (item.producttypecode) {
                  inventoryItem["producttypecode"] = item.producttypecode;
                }

                if (item.description) {
                  inventoryItem["description"] = item.description;
                }

                if (item.requestedQuantity) {
                  inventoryItem["quantity"] = item.requestedQuantity;
                }
                else {
                  inventoryItem["quantity"] = 0;
                }

                if (item.counterOffer) {
                  inventoryItem["priceperunit"] = parseFloat(item.counterOffer)
                }
                else {
                  inventoryItem["priceperunit"] = 0;
                }

                if (item.nyc_upc) {
                  inventoryItem["nyc_upc"] = item.nyc_upc;
                }

                if (item.nyc_sizeuom) {
                  inventoryItem["nyc_sizeuom"] = item.nyc_sizeuom;
                }

                if (item.nyc_qtyonpo) {
                  inventoryItem["nyc_qtyonpo"] = item.nyc_qtyonpo
                }

                if (item.nyc_packaging) {
                  inventoryItem["nyc_packaging"] = item.nyc_packaging;
                }

                if (item.nyc_msrp) {
                  inventoryItem["nyc_msrp"] = item.nyc_msrp;
                }

                if (item.nyc_color) {
                  inventoryItem["nyc_color"] = item.nyc_color;
                }

                if (item.nyc_brand) {
                  inventoryItem["nyc_brand"] = item.nyc_brand;
                }

                if (item.productnumber) {
                  inventoryItem["productnumber"] = item.productnumber;
                }

                if (item.size) {
                  inventoryItem["nyc_size"] = item.size;
                }

                return inventoryItem;
              }

            });
          }
        };

        var processedData = processData(selectedRows, editOrder[0].quotetype);

        console.log("Processed Data: ", processedData);

        if (processedData === null || processedData === undefined) {
          setLoading(false);
          return; // Early exit if validation fails
        }

        const tokenData = localStorage.getItem("auth-token");

        let allApiRequestSuccess = false;

        const apiRequest = async () => {
          const config = {
            headers: {
              'Authorization': `Bearer ${tokenData}`,
              'Content-Type': 'application/json',
            },
            maxContentLength: Infinity,
            maxBodyLength: Infinity,
          };

          try {
            const responses = await Promise.all(
              processedData.map((item) => {
                if (editOrder[0].quotetype === 0) { // atu
                  return axios.post(
                    `${process.env.REACT_APP_CRM_URL}nyc_atulineitems`,
                    JSON.stringify(item),
                    config
                  );
                } else if (editOrder[0].quotetype === 1) { // inventory
                  return axios.post(
                    `${process.env.REACT_APP_CRM_URL}quotedetails`,
                    JSON.stringify(item),
                    config
                  );
                }
              })
            );

            allApiRequestSuccess = responses.every((response) => response && (response.status === 204 || response.status === 200));

          } catch (error) {
            setLoading(false);
            toast.error("Failed to update offer. Please try again.");
            console.log("Failed to update offer. Please try again.", error);
            allApiRequestSuccess = false;
            document.getElementById(`button-addtooffer-${editOrder[0].quoteid}`).setAttribute("disabled", false);
          }
        };


        // // Send the data via API
        if (processedData.length > 0) {
          document.getElementById(`button-addtooffer-${editOrder[0].quoteid}`).setAttribute("disabled", true);
          setLoading(true);

          (async () => {
            await apiRequest(); // Wait until all API requests are complete

            setLoading(false); // Stop loading after the API requests

            if (allApiRequestSuccess) {
              toast.success("Offer updated successfully!");
              navigate("/home/recent-orders");
              setEditOrder([]);

              setTimeout(() => {
                const targetElement = document.getElementById(editOrder[0].quoteid);
                if (targetElement) {
                  targetElement.click();
                } else {
                  console.log("Element not found:", editOrder[0].quoteid);
                }
              }, 0);
            }
          })();
        }

      } catch (error) {
        console.error('Failed to update offer', error);
        setEditOrder([]);
        toast.error('Failed to update offer. Please try again.');
        setLoading(false);
      }
    }
    else {
      toast.warning(`Please select atleast one product`);
    }

  }

  const navigateToOffer = async () => {

    navigate("/home/recent-orders");

    setEditOrder([]);

    setTimeout(() => {
      const targetElement = document.getElementById(editOrder[0].quoteid);
      if (targetElement) {
        targetElement.click();
      } else {
        console.log("Element not found:", editOrder[0].quoteid);
      }
    }, 0);
  }


  return (
    <div class="sticky-bar">
      {/* <span class="pt-1">{selectedRows.length} Products Selected</span> */}
      {
        editOrder && editOrder.length > 0 && editOrder[0].quotetype === 1 && (
          <button onClick={navigateToOffer}>View Offer{" "} {`${'('}${editOrder[0].quotenumber}${')'}`}</button>
        )
      }

      {
        editOrder && editOrder.length > 0 && editOrder[0].quotetype === 1 && (
          <button onClick={handleAddToOrder}>Add to Offer{" "} {`${'('}${editOrder[0].quotenumber}${')'}`}</button>
        )
      }

      <button onClick={handleAddToCart}>Add to Cart</button>
      <Link to="/home/cart">
        <button>
          Checkout{" "}
          {hasCartProducts && (
            <span>{`${'('}${cartProductdetails.length || 0}${')'}`}</span>
          )}
        </button>
      </Link>
    </div>
  );
};

export default IncomingFooter;
